import { render, staticRenderFns } from "./DialogoBuscarProdutos.vue?vue&type=template&id=1235e576&scoped=true&"
import script from "./DialogoBuscarProdutos.vue?vue&type=script&lang=js&"
export * from "./DialogoBuscarProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1235e576",
  null
  
)

export default component.exports